import { Injectable } from '@angular/core';
import { init as initEngagement } from '@amplitude/engagement-browser';

import { SharedCommonUtility } from '../../../shared/utils/common.utility';
import { AppConfigService } from './app-config.service';

export type AmplitudeEngagementUserPropertyValue = string | boolean | number | Date | Array<string> | null | undefined;

export interface IAmplitudeEngagementUserProperties {
  userId: string;
  email: string;
  displayName: string;
  createdDate: AmplitudeEngagementUserPropertyValue;
  lastLoginDate: AmplitudeEngagementUserPropertyValue;
  jobIndustry: string | null;
  jobIndustryName: string | null;
  jobTitle: string | null;
  jobTitleName: string | null;
  roleId: string;
  roleName: string | null;
  signupSurvey: string;
  TID: string;
  tenantName: string | null;
  currentWorkspace: string;
  workspaceName: string | undefined;
  currentDigitalProperty: string;
  digitalPropertyName: string | undefined;
  workspacesCount: number;
  numDpsCurrentWorkspace: number | null;
  SFID: string;
  packageId: string | null;
  packageName: string | null;
  userGroupId: string;
  userGroupName: string;
  staffGroupId: string;
  staffGroupName: string;
}

@Injectable({
  providedIn: 'root',
})
export class AmplitudeEngagementService {
  private initialized: boolean = false;

  constructor(private appConfigService: AppConfigService) {}

  public registerUser(sessionData: IAmplitudeEngagementUserProperties): void {
    const apiKey: string = this.appConfigService.getAmplitudeKey();
    if (apiKey.length === 0 || SharedCommonUtility.isNullishOrEmpty(sessionData?.userId)) {
      return;
    }

    if (this.initialized === false) {
      const proxyBaseUrl: string = `${window.location.origin}/amp`;
      initEngagement(apiKey, {
        serverUrl: `${proxyBaseUrl}/gs`,
        cdnUrl: `${proxyBaseUrl}/cdn`,
        mediaUrl: `${proxyBaseUrl}/media`,
        chatUrl: `${proxyBaseUrl}/chat`,
      });
      this.initialized = true;
    }

    if (SharedCommonUtility.isNullish(window.engagement)) {
      return;
    }

    void window.engagement
      .boot({
        user: {
          user_id: String(sessionData.userId),
          user_properties: sessionData,
        },
        integrations: [],
      })
      .catch((error: unknown) => {
        console.error('[AmplitudeEngagementService] boot failed: ', error);
      });
  }

  public shutdown(): void {
    if (this.initialized === false || SharedCommonUtility.isNullish(window.engagement?.shutdown)) {
      return;
    }

    window.engagement.shutdown();
  }
}
